export class Auth {
  constructor({
    id = null,
    organization_id = null,
    first_name = null,
    last_name = null,
    email = null,
    phone = null,
    designation = null,
    department = null,
    user_type = null,
    user_role = null,
    status = null,
  } = {}) {
    this.id = id;
    this.organization_id = organization_id;
    this.first_name = first_name;
    this.last_name = last_name;
    this.email = email;
    this.phone = phone;
    this.designation = designation;
    this.department = department;
    this.user_type = user_type;
    this.user_role = user_role;
    this.status = status;
  }
}
